<div class="share-results-dialog-container">
  <div *ngIf="data.showConfirmationMessage">
    <h1 mat-dialog-title>{{ confirmationTitle }}</h1>
    <div mat-dialog-content class="share-results-confirmation-wrapper">
      <p [innerHTML]="confirmationMessageBody"></p>
      <p [innerHTML]="confirmationClosing"></p>
    </div>
    <button class="secondary" mat-flat-button (click)="onCancelClick()">{{confirmationCloseButtonText}}</button>
  </div>
  <div *ngIf="!data.showConfirmationMessage">
    <h1 mat-dialog-title>{{title}}</h1>
    <div mat-dialog-content>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{emailLabel}}</mat-label>
          <input cdkFocusInitial matInput [formControl]="email" required>
          <mat-error *ngIf="email.invalid">{{emailErrorMessage}}</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{firstNameLabel}}</mat-label>
          <input matInput [formControl]="firstName" required>
          <mat-error *ngIf="firstName.invalid">{{requiredMessage}}</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{lastNameLabel}}</mat-label>
          <input matInput [formControl]="lastName" required>
          <mat-error *ngIf="lastName.invalid">{{requiredMessage}}</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{companyNameLabel}}</mat-label>
          <input matInput [formControl]="company" required>
          <mat-error *ngIf="company.invalid">{{requiredMessage}}</mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="includeOptInCheckbox">
        <mat-checkbox
          [formControl]="optInToMarketing"
          class="checkbox-field">
          <span class="checkbox-label">{{optInCheckboxLabel}}</span>
        </mat-checkbox>
      </div>
    </div>
    <div mat-dialog-actions>
      <button class="primary" [ngClass]="{ 'non-english' : isNonEnglishLocale }" mat-flat-button (click)="onShareClick()" [disabled]="email.invalid || firstName.invalid || lastName.invalid || company.invalid">{{submitButtonText}}</button>
      <button class="secondary" [ngClass]="{ 'non-english' : isNonEnglishLocale }" mat-flat-button (click)="onCancelClick()">{{cancelButtonText}}</button>
    </div>
  </div>
</div>
